import Modal from '@sdk/components/ui/modal/Modal';
import { PremiumFeatureAccessLevel } from '@sdk/authentication/types';
import useAuth from '@sdk/authentication/useAuth';
import useConfig from '@sdk/config/useConfig';

import { FeatureNames } from '@web/account/types';
import { PremiumModalNames } from '@web/premiumGuard/constants/modalNames';
import { ModalReactInnerWrapper } from '@web/integrations/projectedSalesImport/styles';

import ModalGuardInner from './ModalGuardInner';

type Props = {
  isVisible: boolean;
  premiumFeatureAccessLevel: PremiumFeatureAccessLevel;
  premiumFeatureName: FeatureNames;
  premiumModalName: PremiumModalNames;
  onDismiss: () => void;
};

export const ModalGuard = ({
  isVisible,
  premiumFeatureAccessLevel,
  premiumFeatureName,
  premiumModalName,
  onDismiss,
}: Props) => {
  const { currentUser } = useAuth();
  const { APP_URL } = useConfig();
  const goToBilling = (): void => {
    window.location.href = `${APP_URL}/account/billing`;
  };
  const goToPurchase = (): void => {
    window.location.href = `${APP_URL}/account/purchase`;
  };
  return (
    <Modal isVisible={isVisible} onDismiss={onDismiss}>
      <ModalReactInnerWrapper>
        <ModalGuardInner
          premiumFeatureAccessLevel={premiumFeatureAccessLevel}
          premiumFeatureName={premiumFeatureName}
          premiumModalName={premiumModalName}
          currentUser={currentUser}
          goToBilling={goToBilling}
          purchasePlan={goToPurchase}
        />
      </ModalReactInnerWrapper>
    </Modal>
  );
};
